import React from "react";

import WorkOrderTableRow from "./WorkOrderTableRow";

const WorkOrderTableBody = ({
  disabled,
  options = [],
  remove = () => {},
  fields = [],
}) => {
  return (
    <>
      {fields?.map((item, idx) => (
        <WorkOrderTableRow
          key={item.id}
          idx={idx}
          item={item}
          remove={remove}
          disabled={disabled}
          options={options}
        />
      ))}
    </>
  );
};

export default WorkOrderTableBody;
